export default class ConditionElement extends HTMLElement {

  get selectorId () {
    return this.getAttribute('selector-id');
  }

  get conditionName () {
    return this.getAttribute('condition-name');
  }

  get conditionLabel () {
    return this.getAttribute('condition-label');
  }

  get enabled () {
    return (this.getAttribute('enabled') === 'true');
  }

  get maxSelection () {
    return Number(this.getAttribute('max-selection'));
  }

  activateCondition () {
    /* globals activateCondition */
    activateCondition(this.conditionName);
  }

}
